export default __webpack_public_path__ + "static/media/RshinpadAFE.c72f5a93.svg";